export default "__VITE_ASSET__7dyH3hiH__"